import * as types from '../mutation_types';
import router from '@views/home/router';
import axios from 'axios';

const debug = false;
const debugGetParkingLot = debug;

export default {
  getParkingLot({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      let call;
      if (debugGetParkingLot) {
        call = import('@fixtures/parking-lot-fixture');
      } else {
        const token = router.app.$context.token;
        call = axios.get(`/api/v1/parking-area/?device_size=${payload.device_size}&date=${payload.date}`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        dispatch('parkingLot/setParkingLot', response.data, {root: true});
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setParkingLot({commit}, payload) {
    return new Promise((resolve, reject) => {
      try {
        commit(types.SET_PARKING_LOT, payload);
        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  }
};
